module.exports = __webpack_public_path__ + "img/gaming-controller.7217337b.png";